import types from './types';
import { sfdcRemoting } from './../api';

const actions = {
  async [types.INIT_DASHBOARD_HOME_DATA]({ commit }) {
    let delayedTime = window.location.href.indexOf('/pendingApps') > 0 ? 5000 : 0;

    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('source') || '';

    await new Promise(resolve => setTimeout(resolve, delayedTime));
    const ncaDashboardHomeData = await sfdcRemoting();

    if (!ncaDashboardHomeData.userInfo.hasAcceptedTerms) {
      window.open(`/lendingcircles/NCATermsAndConditions?id=${ncaDashboardHomeData.userInfo.contactId}&source=${source}`, '_self');
      return;
    }
    commit(types.DASHBOARD_HOME_DATA_CHANGED, ncaDashboardHomeData);
    localStorage.setItem('authStatus', 'login');
    return 'success';
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/vuex/actions.js